export const PM_USERS_DELETE_USER_OPEN_MODAL = "PM_USERS_DELETE_USER_OPEN_MODAL";
export const PM_USERS_DELETE_USER_CLOSE_MODAL = "PM_USERS_DELETE_USER_CLOSE_MODAL";

export const PM_USERS_DELETE_USER_REQUEST = "PM_USERS_DELETE_USER_REQUEST";
export const PM_USERS_DELETE_USER_RESULT = "PM_USERS_DELETE_USER_RESULT";